import React, { Fragment, useState, useEffect } from 'react';
import { Button, Modal, Table, Row, Col } from 'react-bootstrap';
import TabelaComponentes from './tabela';
import FormBusca from './busca';
import FormSolicitacao from './formulario';
import ComponentesService from '../../../services/componentes';
import '../../../styles/diario.scss';

function SolicitarScreen() {
    const [componentesOriginais, setComponentesOriginais] = useState([]);
    const [componentes, setComponentes] = useState([]);
    const [filtrou, setFiltrou] = useState(false);
    const [vazio, setVazio] = useState(false);

    const [carrinho, setCarrinho] = useState([]);
    const [showResumo, setShowResumo] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const filtrarLocalmente = (nome, tipo, categoria) => {
        setFiltrou(true);
        const filtrados = componentesOriginais.filter(c => {
            const matchNome = nome ? c.nome.toLowerCase().includes(nome.toLowerCase()) : true;
            const matchTipo = tipo ? c.tipo === tipo : true;
            const matchCategoria = categoria ? c.categoria === categoria : true;
            return matchNome && matchTipo && matchCategoria;
        });

        setComponentes(filtrados);
        setVazio(filtrados.length === 0);
    };

    const adicionarAoCarrinho = (id, qtd) => {
        setCarrinho(prev => [...prev, { componente: id, qtd }]);
    };

    const removerDoCarrinho = (id) => {
        setCarrinho(prev => prev.filter(i => i.componente !== id));
    };

    const atualizarQtd = (id, qtd) => {
        setCarrinho(prev =>
            prev.map(i =>
                i.componente === id ? { ...i, qtd } : i
            )
        );
    };

    const limparCarrinho = () => {
        setCarrinho([]);
    };

    async function fetchComponentes() {
        const response = await ComponentesService.listar();
        setComponentesOriginais(response.data || []);
        setVazio(!response.data || response.data.length === 0);
    }

    useEffect(() => {
        fetchComponentes();
    }, []);

    return (
        <Fragment>
            <FormBusca filtrarLocalmente={filtrarLocalmente} />
            <br />
            <Row xs={2}>
                <Col>
                    <Button
                        className="mb-2 me-2"
                        variant="danger"
                        disabled={carrinho.length === 0}
                        onClick={limparCarrinho}
                    >
                        Limpar todas seleções
                    </Button>
                </Col>
                <Col>
                    <Button
                        className="mb-2"
                        variant="primary"
                        disabled={carrinho.length === 0}
                        onClick={() => setShowResumo(true)}
                    >
                        Solicitar Especificações
                    </Button>
                </Col>
            </Row>
            {!filtrou && (
                <p className="text-muted">
                    Utilize os filtros acima para localizar os componentes desejados.
                </p>
            )}

            {filtrou && vazio && (
                <p className="text-danger">Nenhum componente encontrado.</p>
            )}

            {componentes.length > 0 && (
                <TabelaComponentes
                    componentes={componentes}
                    carrinho={carrinho}
                    onAdicionar={adicionarAoCarrinho}
                    onRemover={removerDoCarrinho}
                    onAtualizarQtd={atualizarQtd}
                />
            )}

            {/* MODAL RESUMO DO CARRINHO */}
            <Modal show={showResumo} onHide={() => setShowResumo(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Itens Selecionados</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Componente</th>
                                <th>Quantidade</th>
                            </tr>
                        </thead>
                        <tbody>
                            {carrinho.map(i => {
                                const comp = componentesOriginais.find(c => c._id === i.componente);
                                return (
                                    <tr key={i.componente}>
                                        <td>{comp?.nome}</td>
                                        <td>{i.qtd}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowResumo(false)}>
                        Voltar
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() => {
                            setShowResumo(false);
                            setShowModal(true);
                        }}
                    >
                        Confirmar e Prosseguir
                    </Button>
                </Modal.Footer>
            </Modal>

            <FormSolicitacao
                show={showModal}
                onHide={() => setShowModal(false)}
                carrinho={carrinho}
                onSucesso={() => {
                    setCarrinho([]);
                }}
            />
        </Fragment>
    );
}

export default SolicitarScreen;
